module.exports = __webpack_public_path__ + "r-v3/img/logo_gooroomee.0678a781.svg";